// extracted by mini-css-extract-plugin
module.exports = {"body":"HorsesBlock_body__19qDu"};